export interface Company {
  uuid: string;
  companyName: string;
  street: string;
  houseNumber: string;
  addressLine2?: string | null;
  postalCode: string;
  city: string;
  country: string;
  phoneNumber?: string | null;
  email?: string | null;
  taxNumber: string;
  uid: string;
  customerId?: string | null;
  canEditCustomerId?: boolean;
  possibleLevels?: Level[];
  level?: Level;
  parentCompany?: {
    uuid: string;
    name: string;
  };
}

export interface Level {
  id: string,
  name: string,
  isActive: boolean,
  hierarchy?: number
};


export interface CompanyFormData {
  companyName: string;
  street: string;
  houseNumber: string;
  addressLine2: string;
  postalCode: string;
  city: string;
  country: string;
  phoneNumber: string;
  email: string;
  taxNumber: string;
  uidNumber: string;
  customerId: string;
  companyId?: string;
  level?: Level;
}

export interface ContactFormData {
  salutation: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  contactEmail: string;
  contactPhone: string;
}

export function companyToFormData(company: Company): CompanyFormData {
  return {
    companyName: company.companyName,
    street: company.street,
    houseNumber: company.houseNumber,
    addressLine2: company.addressLine2 ?? '',
    postalCode: company.postalCode,
    city: company.city,
    country: company.country,
    phoneNumber: company.phoneNumber ?? '',
    email: company.email ?? '',
    taxNumber: company.taxNumber,
    uidNumber: company.uid,
    customerId: company.customerId ?? '',
    companyId: company.uuid,
    level: company.level
  };
}

export function formDataToCompany(
  formData: CompanyFormData,
  uuid: string,
  options: FormDataToCompanyOptions = {}
): Company {
  const company: Company = {
    uuid,
    companyName: formData.companyName,
    street: formData.street,
    houseNumber: formData.houseNumber,
    addressLine2: formData.addressLine2 || null,
    postalCode: formData.postalCode,
    city: formData.city,
    country: formData.country,
    phoneNumber: formData.phoneNumber || null,
    email: formData.email || null,
    taxNumber: formData.taxNumber,
    uid: formData.uidNumber,
    level: formData.level
  };

  if (options.includeCustomerId) {
    company.customerId = formData.customerId;
  }

  return company;
}

interface FormDataToCompanyOptions {
  includeCustomerId?: boolean;
}
